import { render, staticRenderFns } from "./DisplayEmployeeDetail.vue?vue&type=template&id=59a0d669&scoped=true"
import script from "./DisplayEmployeeDetail.vue?vue&type=script&lang=js"
export * from "./DisplayEmployeeDetail.vue?vue&type=script&lang=js"
import style0 from "./DisplayEmployeeDetail.vue?vue&type=style&index=0&id=59a0d669&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a0d669",
  null
  
)

export default component.exports